import React from "react";

import "./ButtonField.scss";

interface ButtonFieldsPropsInterface {
  readonly type: "button" | "submit" | "reset";
  readonly title: string | JSX.Element;
  readonly name?: string;
  readonly className?: string;
  readonly isDisabled?: boolean;
  readonly onClickHandler?: React.MouseEventHandler<HTMLButtonElement>;
}

const ButtonField: React.FC<ButtonFieldsPropsInterface> = (props) => {
  const { type, title, name, className, isDisabled, onClickHandler } = props;
  return (
    <button
      name={name}
      className={className}
      type={type}
      disabled={isDisabled}
      onClick={onClickHandler}
    >
      {title}
    </button>
  );
};

export default ButtonField;
